import { Host, h } from '@stencil/core';
export class AibaNewsletter {
  constructor() {
    this.getDatePerAge = (age) => {
      const date = new Date(new Date().setFullYear(new Date().getFullYear() - age)).toISOString().split('T')[0];
      return date;
    };
    this.handleOnChange = async (event) => {
      var _a, _b, _c, _d, _e, _f, _g;
      let newsLetterValidationSchema;
      if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.getNewsLetterSchema)) {
        newsLetterValidationSchema = await ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.getNewsLetterSchema());
        if (newsLetterValidationSchema) {
          try {
            const validateProperty = async (property, value, schema) => {
              var _a, _b, _c;
              try {
                const result = await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.validateField(property, value, schema));
                if (result.details) {
                  this.formError[property] = (_b = result === null || result === void 0 ? void 0 : result.details[0]) === null || _b === void 0 ? void 0 : _b.message;
                  this.formInvalidError[property] = (_c = result === null || result === void 0 ? void 0 : result.details[0]) === null || _c === void 0 ? void 0 : _c.message;
                  this.finalerr.push(this.formError[property]);
                  this.formData[property] = (result === null || result === void 0 ? void 0 : result._object) ? result === null || result === void 0 ? void 0 : result._object[property] : '';
                }
                else {
                  this.formData[property] = value;
                  this.formError[property] = '';
                }
                this.rerender = !this.rerender;
                const validated = this.validateForm();
                if (validated) {
                  this.validationState = true;
                  this.buttonDisable = false;
                }
                else {
                  this.buttonDisable = true;
                  this.validationState = false;
                }
              }
              catch (err) {
                this.rerender = !this.rerender;
              }
            };
            await validateProperty((_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.name, (_d = event === null || event === void 0 ? void 0 : event.target) === null || _d === void 0 ? void 0 : _d.value, {
              [(_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.name]: newsLetterValidationSchema[(_f = event === null || event === void 0 ? void 0 : event.target) === null || _f === void 0 ? void 0 : _f.name],
            });
            this.finalerr && this.errorIndex === 0 && this.handlers && ((_g = this.handlers) === null || _g === void 0 ? void 0 : _g.formErrorhandler(this.finalerr));
            this.errorIndex = +1;
          }
          catch (err) { }
        }
      }
    };
    this.handleSubmitOnchange = async (data) => {
      let prop = this.formFieldErrors;
      if (prop) {
        for (const elem of prop) {
          const e = {
            target: {
              name: elem,
              value: data[elem],
            },
          };
          await this.handleOnChange(e);
        }
      }
      this.finalerr = [];
      this.errorIndex = 0;
    };
    this.handleCheckbox = async (event) => {
      var _a;
      this.checked = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.checked;
      this.handleFirstInteractionNewsletter();
      this.handlers && this.handlers.handleNewsLetterCheckBox && this.handlers.handleNewsLetterCheckBox(this.checked, event);
    };
    this.handleCloseConfirmBox = e => {
      this.handlers && this.handlers.closeConfirmModalhandler && this.handlers.closeConfirmModalhandler(e);
      this.showNewsletterModal = false;
    };
    this.backToAnalysisClick = async (e) => {
      this.handlers && this.handlers.closeNewsletterModal && this.handlers.closeNewsletterModal(e);
    };
    this.handleSubmitCTAClick = async (event) => {
      var _a, _b, _c;
      this.formSubmit = true;
      this.buttonDisable = true;
      this.error = false;
      ((_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.submitcta) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.checkboxOptional) && (await this.handleSubmitOnchange(this.formData));
      if (!this.validationState) {
        this.handlers && this.handlers.handleErrorNewsletter && (await this.handlers.handleErrorNewsletter());
      }
      if (this.validationState) {
        const response = (await this.handlers) && (await this.handlers.handleNewsLetterSubmit(event, this.formData));
        if (response === true) {
          this.successStatus = true;
          this.error = false;
        }
        if ((response === null || response === void 0 ? void 0 : response.status) === 400) {
          this.error = true;
          this.successStatus = false;
        }
      }
      this.formSubmit = false;
      this.buttonDisable = false;
    };
    this.handleOnInput = (event, element) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j;
      if (!((_b = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a['events']) === null || _b === void 0 ? void 0 : _b['oninput'])) {
        return;
      }
      let inputTimeout;
      event.stopPropagation();
      let eventObject = {
        target: {
          name: (_d = (_c = event === null || event === void 0 ? void 0 : event.target) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
          value: (_f = (_e = event === null || event === void 0 ? void 0 : event.target) === null || _e === void 0 ? void 0 : _e.value) !== null && _f !== void 0 ? _f : '',
        },
      };
      const handleOnChange = this.handleOnChange;
      function handleOnChangeFunc() {
        handleOnChange(eventObject);
      }
      console.log(event);
      let timeoutHandler = clearTimeout(inputTimeout); // Clear the previous timeout
      inputTimeout = setTimeout(handleOnChangeFunc, (_j = (_h = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g['events']) === null || _h === void 0 ? void 0 : _h['timeout']) !== null && _j !== void 0 ? _j : 500);
      return timeoutHandler;
    };
    this.data = undefined;
    this.layoutData = undefined;
    this.handlers = undefined;
    this.buttonDisable = true;
    this.rerender = undefined;
    this.checked = undefined;
    this.successStatus = false;
    this.formSubmit = false;
    this.firstTrigger = false;
    this.validationState = false;
    this._id = undefined;
    this.showNewsletterModal = false;
    this.formV3Filled = false;
    this.formError = {
      email: null,
      name: null,
      firstName: null,
      lastName: null,
      dob: null,
      phoneNumber: null,
    };
    this.formFieldErrors = ['email', 'dob', 'firstName', 'lastName'];
    this.formInvalidError = {
      email: null,
      name: null,
      firstName: null,
      lastName: null,
      dob: null,
      phoneNumber: null,
    };
    this.formKeys = [];
    this.formData = {};
    this.allMandatory = true;
    this.finalerr = [];
    this.error = false;
    this.errorIndex = 0;
  }
  initialiseComponentStates(states) {
    for (const key in states) {
      if (Object.prototype.hasOwnProperty.call(states, key) && states[key] !== undefined) {
        this[key] = states[key];
      }
    }
  }
  async componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    this.allMandatory = (_b = (_a = this === null || this === void 0 ? void 0 : this.data) === null || _a === void 0 ? void 0 : _a.formData) === null || _b === void 0 ? void 0 : _b.allMandatory;
    (_e = (_d = (_c = this.data.formData) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.elements) === null || _e === void 0 ? void 0 : _e.map((element) => {
      var _a, _b;
      if (((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.mandatory) === true) {
        this.formKeys.push((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.name);
      }
    });
    if ((_h = (_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.formData) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.showModal) {
      this.showNewsletterModal = true;
    }
    if (this.handlers && ((_j = this.handlers) === null || _j === void 0 ? void 0 : _j.handleOverrideNewsletterFields)) {
      let { formError, formFieldErrors, formInvalidError } = await ((_k = this.handlers) === null || _k === void 0 ? void 0 : _k.handleOverrideNewsletterFields());
      this.initialiseComponentStates({ formError, formFieldErrors, formInvalidError });
    }
  }
  async componentDidLoad(event) {
    var _a, _b;
    if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.newsLetterComponentDidLoad)) {
      this.handlers && ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.newsLetterComponentDidLoad(event));
    }
  }
  async componentDidUpdate(event) {
    var _a, _b, _c;
    if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.newsLetterComponentDidUpdate)) {
      await ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.newsLetterComponentDidUpdate(event));
    }
    if (this.handlers && ((_c = this.handlers) === null || _c === void 0 ? void 0 : _c.handleV3SubmissionStatus)) {
      this.successStatus && (this.formV3Filled = await this.handlers.handleV3SubmissionStatus(event));
    }
  }
  validateForm() {
    var _a;
    const isError = Object.values(this.formError).some(err => err);
    console.log('Error status2', Error);
    if (isError) {
      return false;
    }
    else {
      if (this.allMandatory) {
        const formData = Object.keys(this.formData).sort();
        const formKeys = (_a = this.formKeys) === null || _a === void 0 ? void 0 : _a.sort();
        return JSON.stringify(formData) === JSON.stringify(formKeys);
      }
    }
    return true;
  }
  handleFirstInteractionNewsletter() {
    if (!this.firstTrigger) {
      this.handlers && this.handlers.handleFirstInteractionNewsletter && this.handlers.handleFirstInteractionNewsletter();
      this.firstTrigger = true;
    }
  }
  handleSubmitCtaRender() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
    return (((_a = this.data) === null || _a === void 0 ? void 0 : _a.submitcta) &&
      ((_c = (_b = this.data) === null || _b === void 0 ? void 0 : _b.submitcta) === null || _c === void 0 ? void 0 : _c.name) === 'aiba-button' && (h("aiba-button", Object.assign({}, (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.submitcta) === null || _e === void 0 ? void 0 : _e.data, { disabled: !((((_h = (_g = (_f = this.data) === null || _f === void 0 ? void 0 : _f.submitcta) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.buttonDisable) ? true : !this.buttonDisable) && (((_l = (_k = (_j = this.data) === null || _j === void 0 ? void 0 : _j.submitcta) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.checkboxOptional) ? true : this.checked)), styles: (_o = (_m = this.data) === null || _m === void 0 ? void 0 : _m.submitcta) === null || _o === void 0 ? void 0 : _o.styles, handleClick: e => this.handleSubmitCTAClick(e), onMouseDown: (_v = (((_r = (_q = (_p = this.data) === null || _p === void 0 ? void 0 : _p.submitcta) === null || _q === void 0 ? void 0 : _q.data) === null || _r === void 0 ? void 0 : _r.events) && ((_u = (_t = (_s = this.data) === null || _s === void 0 ? void 0 : _s.submitcta) === null || _t === void 0 ? void 0 : _t.data) === null || _u === void 0 ? void 0 : _u.events['mousedown']))) !== null && _v !== void 0 ? _v : null, onTouchStart: (_2 = (((_y = (_x = (_w = this.data) === null || _w === void 0 ? void 0 : _w.submitcta) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.events) && ((_1 = (_0 = (_z = this.data) === null || _z === void 0 ? void 0 : _z.submitcta) === null || _0 === void 0 ? void 0 : _0.data) === null || _1 === void 0 ? void 0 : _1.events['touchstart']))) !== null && _2 !== void 0 ? _2 : null }))));
  }
  handleNewsletterRender() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31;
    return this.successStatus ? (h("div", { class: "newsletter-container successStatus", id: this.data._id ? this.data._id : '' }, ((_d = (_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.successState) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d.data) &&
      ((_k = (_j = (_h = (_g = (_f = (_e = this.data) === null || _e === void 0 ? void 0 : _e.successState) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.data) === null || _j === void 0 ? void 0 : _j.elements) === null || _k === void 0 ? void 0 : _k.map((element) => {
        if (element && (element === null || element === void 0 ? void 0 : element.name) === 'aiba-hero-image') {
          return h("aiba-hero-image", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
        }
      })), (_o = (_m = (_l = this.data.successState) === null || _l === void 0 ? void 0 : _l.data) === null || _m === void 0 ? void 0 : _m.elements) === null || _o === void 0 ? void 0 :
      _o.map((element) => {
        var _a, _b;
        if (((_b = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.split('{{firstName}}').length) > 1) {
          element.data.text = element.data.text.replace(/{{(.*?)}}/g, (match, p1) => {
            const key = p1.trim();
            return key in this.formData ? this.formData[key] : match;
          });
        }
        return (h("div", { class: "newsletter-container-label-wrapper" }, (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && element['data']['tag'] === 'h2' && h("aiba-label", Object.assign({}, element['data'])), (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && element['data']['tag'] === 'p' && h("aiba-label", Object.assign({}, element['data'])), (element === null || element === void 0 ? void 0 : element.name) === 'aiba-button' && h("aiba-button", Object.assign({}, element['data'], { handleClick: e => this.backToAnalysisClick(e) })), (element === null || element === void 0 ? void 0 : element.name) === 'br' && h("br", null)));
      }))) : this.formV3Filled ? null : (h("div", { class: "newsletter-container", id: this.data._id ? this.data._id : '' }, ((_q = (_p = this.data) === null || _p === void 0 ? void 0 : _p.image) === null || _q === void 0 ? void 0 : _q.data) &&
      ((_u = (_t = (_s = (_r = this.data) === null || _r === void 0 ? void 0 : _r.image) === null || _s === void 0 ? void 0 : _s.data) === null || _t === void 0 ? void 0 : _t.elements) === null || _u === void 0 ? void 0 : _u.map((element) => {
        if (element && (element === null || element === void 0 ? void 0 : element.name) === 'aiba-hero-image') {
          return h("aiba-hero-image", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
        }
      })), ((_w = (_v = this.data) === null || _v === void 0 ? void 0 : _v.heading) === null || _w === void 0 ? void 0 : _w.data) &&
      ((_z = (_y = (_x = this.data.heading) === null || _x === void 0 ? void 0 : _x.data) === null || _y === void 0 ? void 0 : _y.elements) === null || _z === void 0 ? void 0 : _z.map((element) => {
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-link') {
          return h("aiba-link", Object.assign({ clickEvent: (event) => this.handlers && this.handlers.newsletterlinkhandler(event) }, element === null || element === void 0 ? void 0 : element.data));
        }
      })), h("div", { class: "newsletter-container__inputs" }, ((_1 = (_0 = this.data) === null || _0 === void 0 ? void 0 : _0.formData) === null || _1 === void 0 ? void 0 : _1.data) &&
      ((_4 = (_3 = (_2 = this.data.formData) === null || _2 === void 0 ? void 0 : _2.data) === null || _3 === void 0 ? void 0 : _3.elements) === null || _4 === void 0 ? void 0 : _4.map((element) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-input') {
          return (h("aiba-input", Object.assign({ value: this.formData[(_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.name], styles: this.formData[(_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.styles], onFocusin: () => this.handleFirstInteractionNewsletter(), error: this.formError[(_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.name], minDate: ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.maxAge) ? this.getDatePerAge((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.maxAge) : '', maxDate: ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.minAge) ? this.getDatePerAge((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.minAge) : '', onBlur: e => this.handleOnChange && this.handleOnChange(e), onInput: event => this.handleOnInput(event, element) }, element.data)));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-select-native') {
          return (h("aiba-select-native", Object.assign({ ariaLabel: this.formData[(_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.name], selectValue: this.formData[(_j = element === null || element === void 0 ? void 0 : element.data) === null || _j === void 0 ? void 0 : _j.name], name: this.formData[(_k = element === null || element === void 0 ? void 0 : element.data) === null || _k === void 0 ? void 0 : _k.name], onSelect: e => this.handleOnChange && this.handleOnChange(e), error: this.formError[(_l = element === null || element === void 0 ? void 0 : element.data) === null || _l === void 0 ? void 0 : _l.name], onFocusin: () => this.handleFirstInteractionNewsletter(), onBlur: e => this.handleOnChange && this.handleOnChange(e) }, element.data)));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-weather-assessment') {
          return h("aiba-weather-assessment", Object.assign({}, element, { handlers: this === null || this === void 0 ? void 0 : this.handlers }));
        }
      }))), h("div", { class: "newsletter-container__checkbox" }, h("input", { type: "checkbox", checked: this.checked, onChange: this.handleCheckbox, "aria-label": "checkbox", name: "checkbox", id: "", class: `checkbox ${this.checked ? 'checked' : ''}`, onKeyDown: event => event.key === 'Enter' && (this.checked = !this.checked) }), h("p", { class: "labelcontainer" }, ((_6 = (_5 = this.data) === null || _5 === void 0 ? void 0 : _5.checkBoxData) === null || _6 === void 0 ? void 0 : _6.data) &&
      ((_10 = (_9 = (_8 = (_7 = this.data) === null || _7 === void 0 ? void 0 : _7.checkBoxData) === null || _8 === void 0 ? void 0 : _8.data) === null || _9 === void 0 ? void 0 : _9.elements) === null || _10 === void 0 ? void 0 : _10.map((element) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label')
          return h("aiba-label", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
        if ((element === null || element === void 0 ? void 0 : element.name) === 'br') {
          return h("br", null);
        }
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-link')
          return (h("aiba-link", { href: (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.href, clickEvent: (event) => { var _a; return this.handlers && this.handlers.handleNewsLetterLinkClick((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.href, event); }, title: (_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.title, target: (_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.target, rel: (_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.rel, text: (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.text, styles: element === null || element === void 0 ? void 0 : element.data.styles, arialabel: (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.title }, element &&
            element['data'] &&
            element['data']['elements'] &&
            element['data']['elements'].map((comp) => {
              if (comp && comp['name'] === 'img')
                return h("img", Object.assign({}, comp['data'], { class: "external_link" }));
            })));
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-privacy-links-wrapper') {
          return (h("div", { class: "aiba-privacy-links-wrapper" }, ((_g = element === null || element === void 0 ? void 0 : element['data']) === null || _g === void 0 ? void 0 : _g['elements']) &&
            ((_h = element === null || element === void 0 ? void 0 : element['data']) === null || _h === void 0 ? void 0 : _h['elements'].map(item => {
              var _a;
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-label')
                return h("aiba-label", Object.assign({}, item === null || item === void 0 ? void 0 : item.data));
              if ((item === null || item === void 0 ? void 0 : item.name) === 'aiba-link')
                return (h("aiba-link", Object.assign({}, item === null || item === void 0 ? void 0 : item.data, { clickEvent: (event) => { var _a; return this.handlers && this.handlers.handleNewsLetterLinkClick((_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.href, event); }, arialabel: (_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.title })));
            }))));
        }
      })))), (_12 = (_11 = this.data) === null || _11 === void 0 ? void 0 : _11.element) === null || _12 === void 0 ? void 0 :
      _12.map(element => {
        if ((element === null || element === void 0 ? void 0 : element.name) === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element === null || element === void 0 ? void 0 : element.data));
        }
      }), ((_13 = this.data) === null || _13 === void 0 ? void 0 : _13.skipcta) && ((_15 = (_14 = this === null || this === void 0 ? void 0 : this.data) === null || _14 === void 0 ? void 0 : _14.skipcta) === null || _15 === void 0 ? void 0 : _15.name) === 'aiba-button' && (h("div", { class: "newsletter-container__buttons" }, h("aiba-button", Object.assign({}, (_17 = (_16 = this.data) === null || _16 === void 0 ? void 0 : _16.skipcta) === null || _17 === void 0 ? void 0 : _17.data, { disabled: false, styles: (_19 = (_18 = this.data) === null || _18 === void 0 ? void 0 : _18.skipcta) === null || _19 === void 0 ? void 0 : _19.styles, handleClick: async (event) => {
        this.handlers.handleNewsLetterSkip && (await this.handlers.handleNewsLetterSkip(event));
      } })), this.handleSubmitCtaRender())), (!((_20 = this.data) === null || _20 === void 0 ? void 0 : _20.skipcta) || ((_21 = this === null || this === void 0 ? void 0 : this.data) === null || _21 === void 0 ? void 0 : _21.skipcta.name) !== 'aiba-button') && this.handleSubmitCtaRender(), ((_22 = this.data) === null || _22 === void 0 ? void 0 : _22.skiplink) && ((_24 = (_23 = this.data) === null || _23 === void 0 ? void 0 : _23.skiplink) === null || _24 === void 0 ? void 0 : _24.name) === 'aiba-link' && h("aiba-link", Object.assign({}, (_26 = (_25 = this.data) === null || _25 === void 0 ? void 0 : _25.skiplink) === null || _26 === void 0 ? void 0 : _26.data, { clickEvent: this.backToAnalysisClick })), this.formSubmit && h("aiba-spinner", Object.assign({}, (_28 = (_27 = this === null || this === void 0 ? void 0 : this.data) === null || _27 === void 0 ? void 0 : _27.spinner) === null || _28 === void 0 ? void 0 : _28.data)), this.error &&
      ((_31 = (_30 = (_29 = this.data.failedState) === null || _29 === void 0 ? void 0 : _29.data) === null || _30 === void 0 ? void 0 : _30.elements) === null || _31 === void 0 ? void 0 : _31.map((element) => {
        return h("div", { class: "error-message" }, (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && h("aiba-label", Object.assign({}, element['data'])));
      }))));
  }
  render() {
    var _a, _b, _c, _d, _e, _f;
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, { ref: el => (this.newsletterPopupRef = el) }, this.handleNewsletterRender(), this.showNewsletterModal && (h("aiba-modal", { handleClick: this.handleCloseConfirmBox, handlers: this === null || this === void 0 ? void 0 : this.handlers, modalPosition: (_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.modal) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.modalPosition, closeButtonData: (_f = (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.modal) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.closeButtonData }, this.handleNewsletterRender()))));
  }
  static get is() { return "aiba-newsletter"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-newsletter.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-newsletter.css"]
    };
  }
  static get properties() {
    return {
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "layoutData": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "layout-data",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "formFieldErrors": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "string[]",
          "resolved": "string[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "['email', 'dob', 'firstName', 'lastName']"
      },
      "finalerr": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "any[]",
          "resolved": "any[]",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "defaultValue": "[]"
      },
      "error": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error",
        "reflect": false,
        "defaultValue": "false"
      },
      "errorIndex": {
        "type": "number",
        "mutable": false,
        "complexType": {
          "original": "number",
          "resolved": "number",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "error-index",
        "reflect": false,
        "defaultValue": "0"
      }
    };
  }
  static get states() {
    return {
      "buttonDisable": {},
      "rerender": {},
      "checked": {},
      "successStatus": {},
      "formSubmit": {},
      "firstTrigger": {},
      "validationState": {},
      "showNewsletterModal": {},
      "formV3Filled": {},
      "formError": {},
      "formInvalidError": {},
      "formKeys": {},
      "formData": {},
      "allMandatory": {}
    };
  }
}
//# sourceMappingURL=aiba-newsletter.js.map
